<template>
    <div class="tender-cost flex-layout">
        <list-layout-paper>
            <div slot="header-search">
                <div>
                    <mSelect class="el-input" :optionNum="'BID_EXPENSE_ORDER_TYPE'" :value="editorInfo.orderType" :placeholder="'费用类型'" :filterable="true" @input="getOrderType"></mSelect>
                    <mSelect class="el-input" :optionNum="'BID_COST_STATUS'" :value="editorInfo.costStatus" :placeholder="'状态'" :filterable="true" @input="getCostStatus"></mSelect>
                    <el-input v-model.trim="editorInfo.bidNo" placeholder="招标项目编码" size="mini" clearable></el-input>
                    <el-input v-model.trim="editorInfo.bidName" placeholder="招标项目名称" size="mini" clearable></el-input>
                    <el-date-picker
                        v-model="editorInfo.orderTime"
                        size="mini"
                        type="datetime"
                        placeholder="下单时间从"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                    <el-button type="primary" size="mini" class="paddingleft bigData-btn-search" @click="searchFn">查 询</el-button>
                </div>
            </div>
            <div slot="header-button" class="top-header">
                <el-tooltip effect="dark" content="刷新" placement="bottom" class="m-l">
                    <el-button icon="el-icon-refresh" size="mini" @click="refreshFn"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="列配置" placement="bottom" class="m-l">
                    <el-button icon="el-icon-setting" size="mini" @click="colDispose"></el-button>
                </el-tooltip>
            </div>

            <el-table slot="list" v-loading="loading" :data="costList" class="list-table" border stripe ref="table" height="200">
                <el-table-column
                    v-for="(item, index) in columnsList"
                    :key="index"
                    :width="item.width"
                    :prop="item.prop"
                    :label="item.label">
                </el-table-column>
                <el-table-column prop="action" label="操作" width="210" align="center" fixed="right">
                    <template slot-scope="scope">
                        <span v-has="'06020002'">
                            <form id="buyformCommit" class="form-box margin-right"
                                v-if="scope.row.orderType === '1' && scope.row.costStatus === '1'" :action="config.mideaPay" method="psot">
                                <input type="hidden" :name="key" :value="val"  v-for="(val,key) of payResult" :key="key"/>
                                <span class="buy-bidbook" @click="buyBtn(scope.row, '1')">购买标书</span>
                            </form>
                        </span>
                        <span v-has="'06020003'">
                            <el-button size="mini" type="text" @click="bondFn(scope.row)"  class="margin-right"
                            v-if="scope.row.payType !== '2' && scope.row.orderType === '2' &&
                            (scope.row.costStatus === '1' || scope.row.costStatus === '4') && !scope.row.depositEndTimeFlag">缴纳保证金</el-button>
                        </span>
                        <span v-has="'06020003'">
                            <form id="formCommit" class="form-box margin-right"
                                v-if="scope.row.payType === '2' && scope.row.orderType === '2' &&
                                (scope.row.costStatus === '1' || scope.row.costStatus === '4') && !scope.row.depositEndTimeFlag"
                                :action="config.mideaPay" method="post">
                                <input type="hidden" :name="key" :value="val"  v-for="(val,key) of payResult" :key="key"/>
                                <el-button type='text' @click="bondFn(scope.row)">缴纳保证金</el-button>
                            </form>
                        </span>
                        <span v-has="'06020004'">
                            <el-button size="mini" type="text" class="margin-right"
                                v-if="
                                scope.row.refundAmount > 0 &&
                                scope.row.orderType === '2' &&
                                scope.row.costStatus === '5' &&
                                scope.row.bidStatus === '80' &&
                                scope.row.operationStatus !== '1'&&
                                scope.row.priceDifference!=='0.00'"
                                @click="refundFn(scope.row)">申请退款</el-button>
                        </span>
                        <span v-has="'06020001'">
                            <el-button class="margin-right" size="mini" type="text" @click="gotoCostDetail(scope.row)">查看</el-button>
                        </span>
                        <span v-has="'06020005'">
                            <el-button class="margin-right" size="mini" type="text" @click="cancelFn(scope.row)"
                                v-if="(scope.row.orderType === '1' && scope.row.costStatus === '1') ||
                                (scope.row.orderType === '3' && (scope.row.costStatus === '1' || scope.row.costStatus === '4')) ||
                                (scope.row.orderType === '2' && (scope.row.costStatus === '1' || scope.row.costStatus === '4'))">取消</el-button>
                        </span>
                        <span v-has="'06020006'">
                            <el-button class="margin-right" v-if="scope.row.orderType === '3' && (scope.row.costStatus === '7' || scope.row.costStatus === '1')"
                                size="mini" type="text" @click="refundStamp(scope.row)">退款申请函盖章</el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination slot="footer"
                class="text-right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageInfo.pageNo"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="pageInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </list-layout-paper>
        <el-dialog :visible.sync="showModal" title="列配置" @close="dialogClose">
            <configuration :checkedList="checkedList" :selectAllColumns="selectAllColumns" ref="dialog"
                @getTableConfigList="getTableConfigList" @tableConfigClose="tableConfigClose" :columnNum='columnNum'></configuration>
        </el-dialog>
        <Bid-Price-List :payTitle="'退款申请函盖章'" :originFlag="'2'" :MDialogshow="bidPayshow" :rowBidDialogData="bidPayshowRowData" @mdialogFn="mdialogFn"></Bid-Price-List>
        <payDialog :showPd="payshow" :payDialogRowData="payDialogRowData" @payDialogEvent="payDialogEvent" :payTitle="'缴纳保证金'"></payDialog>
    </div>

</template>
<script>
import { mapGetters } from 'vuex';
import payDialog from '../bidManagement/payDialog.vue';
import MSelect from '@/components/lots/otpSelect2';
import ListLayoutPaper from '@/components/lots/listLayout/Paper';
import configuration from '@/components/otpPanel/configuration-list';
import BidPriceList from '../bidManagement/BidPriceList.vue';
import { getList } from '../../../../lsrm/api/annoMana.js';
import { bidSupplierCostList, bidSupplier } from '../../../../lsrm/api/tenderCost.js';
import { costOrderPay } from '../../../../lsrm/api/myBidding.js';
import { dictWithUrl } from '@/components/lots/api';
import config from '@/config/user.env.js';
export default {
    name: 'tenderCost',
    components: { ListLayoutPaper, configuration, MSelect, payDialog, BidPriceList },
    data() {
        return {
            config,
            bidPayshow: false,
            bidPayshowRowData: {},
            resourceCode: '',
            editorInfo: {
                orderTime: '',
                bidNo: '',
                orderType: '',
                costStatus: '',
                bidName: ''
            },
            pageInfo: {
                pageNo: 1,
                pageSize: 10
            },
            total: 0,
            costList: [],
            loading: false,
            columnNum: 100,
            showModal: false,
            checkedList: '',
            selectAllColumns: [{
                prop: 'orderNo',
                label: '订单号',
                width: '180'
            }, {
                prop: 'orderTypeText',
                label: '订单类型',
                width: '180'
            }, {
                prop: 'costStatusText',
                label: '状态',
                width: '180'
            }, {
                prop: 'bidNo',
                label: '招标项目编码',
                width: '180'
            }, {
                prop: 'bidName',
                label: '招标项目名称',
                width: '180'
            }, {
                prop: 'receivePayAmount',
                label: '应付/退款金额(元)',
                width: '180'
            }, {
                prop: 'actualReceivePay',
                label: '实付/退款金额(元)',
                width: '180'
            }, {
                prop: 'penaltyAmount',
                label: '罚扣款金额(元)',
                width: '180'
            }, {
                prop: 'payTypeText',
                label: '缴纳方式',
                width: '180'
            }, {
                prop: 'orderTime',
                label: '下单时间',
                width: '180'
            }, {
                prop: 'transactionTime',
                label: '付/退款时间',
                width: '180'
            }, {
                prop: 'costRejectionCause',
                label: '驳回原因',
                width: '180'
            }, {
                prop: 'contactName',
                label: '联系人',
                width: '180'
            }, {
                prop: 'contactNumber',
                label: '联系方式',
                width: '180'
            }],
            columnsList: [{
                prop: 'orderNo',
                label: '订单号',
                width: '180'
            }, {
                prop: 'orderTypeText',
                label: '订单类型',
                width: '180'
            }, {
                prop: 'costStatusText',
                label: '状态',
                width: '180'
            }, {
                prop: 'bidNo',
                label: '招标项目编码',
                width: '180'
            }, {
                prop: 'bidName',
                label: '招标项目名称',
                width: '180'
            }, {
                prop: 'receivePayAmount',
                label: '应付/退款金额(元)',
                width: '180'
            }, {
                prop: 'actualReceivePay',
                label: '实付/退款金额(元)',
                width: '180'
            }, {
                prop: 'penaltyAmount',
                label: '罚扣款金额(元)',
                width: '180'
            }, {
                prop: 'payTypeText',
                label: '缴纳方式',
                width: '180'
            }, {
                prop: 'orderTime',
                label: '下单时间',
                width: '180'
            }, {
                prop: 'transactionTime',
                label: '付/退款时间',
                width: '180'
            }, {
                prop: 'costRejectionCause',
                label: '驳回原因',
                width: '180'
            }, {
                prop: 'contactName',
                label: '联系人',
                width: '180'
            }, {
                prop: 'contactNumber',
                label: '联系方式',
                width: '180'
            }],
            totalCount: 1,
            payResult: {},
            payshow: false,
            payDialogRowData: {},
            dictData: [],
            timestamp: 0
        };
    },
    mounted() {
        const param = { ...this.pageInfo, ...this.editorInfo };
        dictWithUrl('BID_EXPENSE_ORDER_TYPE,BID_PAY_TYPE,BID_COST_STATUS').then(res => {
            this.dictData = res.data;
            this.loadData(param);
            this.setConfigColumn();
        });
    },
    methods: {
        refundStamp(row) {
            this.bidPayshow = true;
            this.bidPayshowRowData = row;
        },
        mdialogFn() {
            this.bidPayshow = false;
        },
        payDialogEvent(data) {
            this.payshow = false;
        },
        bondFn(row) {
            if (!row.payType) {
                this.payshow = true;
                this.payDialogRowData = row;
            } else {
                if (row.payType === '1') {
                    this.$router.push({ name: 'payBidDetail', query: { payType: '1', id: row.id } });
                } else if (row.payType === '2') {
                    let returnUrl = '';
                    if (config.apiUrl !== '/') {
                        returnUrl = 'https:' + config.apiUrl + '/api-srm-web/public/bidPayCallBack';
                    } else {
                        returnUrl = 'https://anapi-sit.annto.com/api-srm-web/public/bidPayCallBack';
                    }
                    const par = {
                        orderType: '2',
                        bidNo: row.bidNo,
                        supplierCode: row.supplierCode,
                        supplierName: row.supplierName,
                        contactNumber: row.contactNumber,
                        returnUrl: returnUrl
                    };
                    costOrderPay(par).then(res => {
                        if (res && +res.code === 0) {
                            this.payResult = JSON.parse(res.data.payResult);
                            setTimeout(() => {
                                document.getElementById('formCommit').submit();
                            }, '500');
                        }
                    });
                } else if (row.payType === '3') {
                    this.$router.push({ name: 'payFreight', query: { payType: '3', id: row.id, bidNo: row.bidNo, supplierCode: row.supplierCode } });
                }
            }
        },
        buyBtn(row, type) {
            const par = {
                orderType: type,
                bidNo: row.bidNo,
                supplierCode: row.supplierCode,
                contactNumber: row.contactNumber,
                returnUrl: location.origin + location.pathname + location.hash
            };
            costOrderPay(par).then(res => {
                if (res && +res.code === 0) {
                    this.payResult = JSON.parse(res.data.payResult);
                    setTimeout(() => {
                        document.getElementById('buyformCommit').submit();
                    }, '500');
                }
            });
        },
        cancelFn(row) {
            bidSupplier(row.id).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('取消成功！');
                    const param = { ...this.pageInfo, ...this.editorInfo };
                    this.loadData(param);
                }
            });
        },
        gotoCostDetail(row) {
            this.$router.push({ name: 'costDetail', query: { id: row.id, orderType: row.orderType } });
        },
        refundFn(row) {
            this.$router.push({ name: 'refundApplication', query: { bidNo: row.bidNo, supplierCode: row.supplierCode, orderNo: row.orderNo } });
        },
        refreshFn() {
            this.loadData(this.editorInfo);
        },
        setConfigColumn() {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            this.deepMenu(menu);
            const pramas = {
                'moduleCode': this.resourceCode,
                'subjectType': 'tenderList'
            };
            getList.get(pramas).then(res => {
                if (res.data) {
                    const datas = res && res.data.configNameCn ? res.data.configNameCn.split(',') : [];
                    const colList = [];
                    if (!datas.length) {
                        this.selectAllColumns.map(data => {
                            colList.push(data);
                        });
                    } else {
                        datas.map(title => {
                            this.selectAllColumns.map(data => {
                                if (data.label === title) {
                                    colList.push(data);
                                }
                            });
                        });
                    }
                    this.columnsList = colList;
                    const arr = [];
                    this.columnsList.forEach(el => {
                        arr.push(el.label);
                    });
                    this.checkedList = arr.join(',');
                }
            });
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    this.depfunc(childrens);
                }
            }
        },
        depfunc(childrens) {
            for (let i = 0; i < childrens.length; i++) {
                if (childrens[i].frontUrl === this.$route.path || (childrens[i].frontUrl === '/index' && this.$route.path === '/')) {
                    this.resourceCode = childrens[i].resourceCode;
                } else {
                    this.deepMenu(childrens[i]);
                }
            }
        },
        searchFn() {
            this.pageInfo.pageNo = 1;
            const seachparam = { ...this.pageInfo, ...this.editorInfo };
            this.loadData(seachparam);
        },
        getCostStatus(value) {
            this.editorInfo.costStatus = value;
        },
        getOrderType(value) {
            this.editorInfo.orderType = value;
        },
        loadData(serachObj) {
            serachObj.supplierCode = this.$store.state.supplier.supplierCode;
            bidSupplierCostList(serachObj).then((res) => {
                if (+res.code === 0) {
                    const list = res.data.list;
                    this.totalCount = res.data.totalCount;
                    this.timestamp = new Date(res.timestamp).getTime();
                    if (list.length > 0) {
                        this.costList = this.parameReset(list);
                        this.costList.forEach(item => {
                            item.priceDifference = this.sub(item.actualReceivePay, item.penaltyAmount);
                            item.priceDifference = this.sub(item.priceDifference, item.depositContract);
                        });
                    } else {
                        this.costList = list;
                    }
                }
            });
        },
        parameReset(list) {
            list.forEach(el => {
                const depositEndTime = new Date(el.depositEndTime).getTime();
                el.depositEndTimeFlag = this.timestamp > depositEndTime; // 保证金截止时间
                el.refundAmount = this.sub(el.actualReceivePay, el.penaltyAmount);
                el.orderTypeText = this.dictData.BID_EXPENSE_ORDER_TYPE[el.orderType];
                el.payTypeText = this.dictData.BID_PAY_TYPE[el.payType];
                el.costStatusText = this.dictData.BID_COST_STATUS[el.costStatus];
            });
            return list;
        },
        sub(arg1, arg2) {
            // 减法精度处理
            let r1 = ''; let r2 = ''; let m = ''; let n = '';
            try { r1 = arg1.toString().split('.')[1].length; } catch (e) { r1 = 0; }
            try { r2 = arg2.toString().split('.')[1].length; } catch (e) { r2 = 0; }
            m = Math.pow(10, Math.max(r1, r2));
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m) / m).toFixed(n);
        },
        colDispose() {
            this.showModal = true;
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            this.showModal = false;
            const pramas = {
                'configName': tabelConfigName,
                'configNameCn': tabelConfigList,
                'subjectType': 'tenderList',
                'moduleCode': this.resourceCode
            };
            getList.post(pramas).then(() => {});

            const datas = tabelConfigList.split(',');
            const columnsList = [];
            datas.map(title => {
                this.selectAllColumns.map(data => {
                    if (data.label === title) {
                        columnsList.push(data);
                    }
                });
            });
            this.columnsList = columnsList;
        },
        tableConfigClose() {
            this.showModal = false;
        },
        dialogClose() {
            this.showModal = false;
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNo = val;
            const params = { ...this.pageInfo, ...this.editorInfo };
            this.loadData(params);
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            const params = { ...this.pageInfo, ...this.editorInfo };
            this.loadData(params);
        }
    },
    watch: {
    },
    computed: {
        ...mapGetters(['menus'])
    }
};
</script>
<style lang="less">
.tender-cost {
    .margin-right {
        margin-right: 10px;
    }
    .point {
        width:8px;
        height: 8px;
        display:inline-block;
        border-radius:100%;
    }
    .btn-action {
        font-size: 12px;
        color: #666;
    }
    .top-header {
        min-width:142px;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
    }
    .list-table {
        width: 100%;
        .buy-bidbook  {
            font-size: 12px;
            cursor: pointer;
            color: #00BCBF;
        }
        .form-box {
            display: inline-block;
        }
    }
    .m-l {
        margin-left: 10px;
    }
    .list-table.el-table {
        min-height: calc(~"100vh - 190px");
        max-height: calc(~"100vh - 190px");
    }
}
</style>